import notificationSound from '../static/Notification.mp3'
import exceptionSound from '../static/audio/exception.mp3'
import { soundNotification } from './soundNotification'
import { Toast, ToastMessage } from 'primereact/toast'
import { ReactNode, RefObject } from 'react'
import { toast } from 'react-toastify'

export enum NotificationTypes {
    Notification = 'success',
    Exception = 'error',
}

export const NotificationTypeSoundMapper: Record<NotificationTypes, string> = {
    [NotificationTypes.Notification]: notificationSound,
    [NotificationTypes.Exception]: exceptionSound,
}

interface Options extends ToastMessage {
    type: NotificationTypes;
    header?: ReactNode;
    content?: ReactNode;
}

export function _notify(
    _ref: RefObject<Toast> | Toast,
    { type, content }: Options,
    sound?: boolean,
): void {
    toast[type](content, {
        position: 'top-center',
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
    })
    
    if (sound) {
        soundNotification(type)
    }
}

export type ToastNotificationOptions = {
    toast?: RefObject<Toast> | null;
    type: NotificationTypes;
    content: ReactNode;
    sound?: boolean;
}

export type ToastNotificationAction<Options> = (options: Options) => void;

export type ToastDirectNotificationOptions = Omit<ToastNotificationOptions, 'type'>;

export const notify: ToastNotificationAction<ToastNotificationOptions> = (options: ToastNotificationOptions): void => {
    const toast: Toast = options.toast?.current ?? window.Toast
    
    _notify(
        toast,
        {
            type: options.type,
            content: options.content,
        },
        options.sound !== undefined ? options.sound : true,
    )
}

export const notifyAboutSuccess: ToastNotificationAction<
    ToastDirectNotificationOptions
> = (options: ToastDirectNotificationOptions): void => {
    const { toast = null, content, sound = false } = options;
    return notify({
        toast,
        content,
        sound,
        type: NotificationTypes.Notification,
    });
};

export const notifyAboutException: ToastNotificationAction<ToastDirectNotificationOptions> = (
    options: ToastDirectNotificationOptions,
): void => {
    return notify({
        ...options,
        type: NotificationTypes.Exception,
    })
}
